import { render, staticRenderFns } from "./QustionsTrans.vue?vue&type=template&id=2c626c82&scoped=true"
import script from "./QustionsTrans.vue?vue&type=script&lang=js"
export * from "./QustionsTrans.vue?vue&type=script&lang=js"
import style0 from "./QustionsTrans.vue?vue&type=style&index=0&id=2c626c82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c626c82",
  null
  
)

export default component.exports